import { ARTISANS } from "../data/site";
import { ArrowUpRight, MapPin } from "lucide-react";

export default function ArtisanStories() {
  return (
    <section
      id="stories"
      data-testid="artisan-stories-section"
      className="relative py-24 md:py-36 px-6 md:px-12 lg:px-20 bg-[#0B0B0B]"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center reveal max-w-3xl mx-auto mb-16 md:mb-20">
          <span className="text-[11px] tracking-[0.42em] uppercase text-[#D4AF37]">
            The Makers
          </span>
          <h2 className="mt-5 font-serif-display text-[34px] sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-white">
            Hands behind <br />
            <span className="italic text-gold-shimmer">every heirloom.</span>
          </h2>
          <p className="mt-6 text-[15px] leading-[1.9] text-white/65 font-light">
            Three of the artisans whose skill, patience, and memory make Kendi
            Collections possible.
          </p>
        </div>

        {/* Story cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {ARTISANS.map((a, i) => (
            <article
              key={a.id}
              data-testid={`artisan-card-${a.id}`}
              className="card-sheen block reveal group"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="relative overflow-hidden aspect-square">
                <picture>
                  <source type="image/webp" srcSet={a.image.replace(/\.jpg$/, ".webp")} />
                  <img
                    src={a.image}
                    alt={`${a.craft} — ${a.region}`}
                    loading="lazy"
                    width="1000"
                    height="1000"
                    className="w-full h-full object-cover"
                    onError={(e) => (e.currentTarget.style.display = "none")}
                  />
                </picture>
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B]/85 via-[#0B0B0B]/30 to-transparent" />

                {/* Region chip */}
                <div className="absolute top-4 left-4 z-10 px-3 py-1 border border-[#D4AF37]/40 backdrop-blur-md bg-[#0B0B0B]/50 inline-flex items-center gap-1.5">
                  <MapPin className="w-3 h-3 text-[#D4AF37]" />
                  <span className="text-[9px] tracking-[0.32em] uppercase text-[#D4AF37]">
                    {a.region}
                  </span>
                </div>

                {/* Name + craft at bottom */}
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6 z-10">
                  <p className="text-[10px] tracking-[0.42em] uppercase text-[#D4AF37] mb-1">
                    {a.craft}
                  </p>
                  <h3 className="font-serif-display text-2xl md:text-3xl text-white leading-tight">
                    {a.name}
                  </h3>
                </div>
              </div>

              {/* Story body */}
              <div className="p-6 md:p-7 border-t border-[#262626]">
                <p className="text-[13px] leading-[1.85] text-white/70 font-light italic">
                  “{a.story}”
                </p>
                <a
                  href="#support"
                  data-testid={`artisan-support-link-${a.id}`}
                  className="mt-5 gold-link text-[10px]"
                >
                  Support their work
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
